import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="locations-selector"
export default class extends Controller {
  static outlets = ["polaris-autocomplete"];
  static targets = ["locationsGidField"];

  locationsGidFieldTargetConnected() {
    this.locationAutocompleteOutlet.inputTarget.addEventListener(
      "blur",
      this.onLocationInputBlurred,
    );
  }

  locationsGidFieldTargetDisconnected() {
    if (this.locationAutocompleteOutlet) {
      this.locationAutocompleteOutlet.inputTarget.removeEventListener(
        "blur",
        this.onLocationInputBlurred,
      );
    }
  }

  onLocationInputBlurred = (event) => {
    const locationAutocompleteOutlet = this.locationAutocompleteOutlet;

    locationAutocompleteOutlet.optionTargets.forEach((option) => {
      option.classList.remove("Polaris--hidden");
    });

    const selectedValue = locationAutocompleteOutlet.hiddenInputTarget.value;

    const selectedOption = locationAutocompleteOutlet.optionTargets.find(
      (option) => {
        const input = option.querySelector("input");

        return input.value === selectedValue;
      },
    );

    if (selectedOption) {
      if (event.target.value === selectedOption.dataset.label) {
        return;
      }

      event.target.value = selectedOption.dataset.label;
    }
  };

  resetLocationGidField() {
    const locationAutocompleteOutlet = this.locationAutocompleteOutlet;
    if (locationAutocompleteOutlet) {
      if (locationAutocompleteOutlet.hasHiddenInputTarget) {
        locationAutocompleteOutlet.hiddenInputTarget.value = "";
      }
      if (locationAutocompleteOutlet.hasInputTarget) {
        locationAutocompleteOutlet.inputTarget.value = "";
      }

      locationAutocompleteOutlet.reset();
    }
  }

  get locationAutocompleteOutlet() {
    return this.polarisAutocompleteOutlets.find(
      (outlet) => outlet.element.id === "locations-gid-autocomplete",
    );
  }
}
